export default "__VITE_ASSET__C$fh_afl__"